import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';

GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export const hasAttachmentValidPdfStructure = async (src: string | ArrayBuffer): Promise<boolean> => {
  const loadingTask = getDocument(src);

  try {
    const pdfDocument = await loadingTask.promise;
    return !!pdfDocument.numPages;
  } catch {
    return false;
  } finally {
    await loadingTask.destroy().catch(() => {});
  }
};
